var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCailiaobiao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.25,
    y: 1.5,
    width: 13,
    height: 13,
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.75,
    y: 2,
    width: 12,
    height: 2,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8609 9C11.8609 10.7182 10.468 12.1111 8.74978 12.1111C7.03156 12.1111 5.63867 10.7182 5.63867 9C5.63867 7.28178 7.03156 5.88889 8.74978 5.88889C10.468 5.88889 11.8609 7.28178 11.8609 9Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 12.6C10.7382 12.6 12.35 10.9882 12.35 9C12.35 7.01177 10.7382 5.4 8.75 5.4C6.76177 5.4 5.15 7.01177 5.15 9C5.15 10.9882 6.76177 12.6 8.75 12.6ZM11.7611 9C11.7611 10.663 10.413 12.0111 8.75 12.0111C7.08701 12.0111 5.73889 10.663 5.73889 9C5.73889 7.33701 7.08701 5.98889 8.75 5.98889C10.413 5.98889 11.7611 7.33701 11.7611 9Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0357 9.5C11.3237 8.69377 11.5714 7.75 11.0357 7C11.3929 7.5 11.75 8 11.75 9C11.75 11.5 9.78571 12 8.89286 12C8.17857 12 7.46429 11.75 6.75 11C8.17857 12.5 10.6786 10.5 11.0357 9.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCailiaobiao);
export default __webpack_public_path__ + "static/media/cailiaobiao.5240d7c3e3079eb2897f1ef33239e678.svg";
export { ForwardRef as ReactComponent };